import { Col, Collapse, Row, Table } from "reactstrap";

import styles from "./tnc.module.scss";

export const TNC = ({ accordionOpen }) => {
	return (
		<Collapse isOpen={accordionOpen}>
			<div
				dangerouslySetInnerHTML={{
					__html: `
                    <h3 class="fs17 mb-0 mt-3">1. Final Course Selection</h3>
                    <p>Once the learner has confirmed the list of courses to be printed on the certificate, no changes will be permitted. Please ensure the information is accurate before submission.</p>

                    <h3 class="fs17 mb-0 mt-3">2. Final Folder Selection</h3>
                    <p>Once a certificate folder has been selected, no changes can be made. Please review your selection carefully before confirming your request.</p>

                    <h3 class="fs17 mb-0 mt-3">3. Non-Refundable Payment</h3>
                    <p>All payments made for the physical certificate are strictly non-refundable, regardless of change in preference, errors in course or folder selection, or cancellation requests after submission.</p>

                    <h3 class="fs17 mb-0 mt-3">4. Accuracy of Learner Details</h3>
                    <p>Learners are responsible for verifying their full name and course titles before final confirmation. Skills Development Academy will not be responsible for errors submitted by the learner.</p>

                    <h3 class="fs17 mb-0 mt-3">5. Delivery Scope</h3>
                    <p>Physical certificate delivery is available only within Singapore. A valid and complete local address must be provided.</p>

                    <h3 class="fs17 mb-0 mt-3">6. Processing and Delivery Timeline</h3>
                    <p>The certificate will be processed and dispatched within 30 calendar days from the date of confirmation. Tracking details will be provided once the item is shipped.</p>

                    <h3 class="fs17 mb-0 mt-3">7. Delivery Responsibility</h3>
                    <p>Learners must ensure that the delivery address provided is accurate and that someone is available to receive the package. Skills Development Academy will not be liable for failed deliveries due to incorrect or incomplete address details.</p>

                    <h3 class="fs17 mb-0 mt-3">8. Redelivery Charges</h3>
                    <p>In the event of a failed delivery (e.g., due to incorrect address or recipient unavailability), any additional redelivery costs will be borne by the learner.</p>

                    <h3 class="fs17 mb-0 mt-3">9. Damage or Non-Receipt</h3>
                    <p>If the certificate is damaged upon delivery or not received, learners must notify Skills Development Academy within 3 working days from the delivery date. Requests made after this period may not be accommodated.</p>

                    <h3 class="fs17 mb-0 mt-3">10. Limitation of Liability</h3>
                    <p>Skills Development Academy will not be held responsible for delivery delays caused by third-party courier services, public holidays, or unforeseen circumstances.</p>

                    <h3 class="fs17 mb-0 mt-3">11. Acknowledgement of Terms</h3>
                    <p>By submitting a request for the physical certificate, the learner acknowledges and agrees to the above terms and conditions.</p>
                    `,
				}}></div>
		</Collapse>
	);
};
